import { BlobServiceClient } from "@azure/storage-blob";

import {
  AZURE_STORAGE_BLOB_URL,
  AZURE_BLOB_SAS_TOKEN,
  DOMAIN,
  generateToken,
  ACTIVE_SUBSCRIPTION_KEY,
} from "../constant";

import axios from "axios";
import moment from "moment";

export const resources = {
  1: "en",
  2: "hi",
};

export const langResources = {
  en: {
    offersForYou: "Offers For You",
    noOffersAvailable: "No Offers Available",
  },
  hi: {
    offersForYou: "आपके लिए ऑफर",
    noOffersAvailable: "आपके लिए कोई ऑफ़र उपलब्ध नहीं है",
  },
};

const TokenExpiry = 57; //in mins
const UserExpiry = 12; //in hours

export const arrUniqBy = (arr, p) => {
  if (arr) {
    const val = arr.reduce((map, item) => {
      if (item && item[p]) {
        if (map.has(item[p])) {
          return map;
        }
        map.set(item[p], item);
      }
      return map;
    }, new Map());
    return Array.from(val.values());
  }
  return [];
};

const createBlobInContainer = async (containerClient, file) => {
  // create blobClient for container
  const blobClient = containerClient.getBlockBlobClient(`html/${file.name}`);

  // set mimetype as determined from browser with file upload control
  const options = { blobHTTPHeaders: { blobContentType: file.type } };

  // upload file
  await blobClient.uploadBrowserData(file, options);
};

export const uploadFileToBlob = async (file) => {
  if (!file) return null;

  // get BlobService = notice `?` is pulled out of sasToken - if created in Azure portal
  const blobService = new BlobServiceClient(
    `${AZURE_STORAGE_BLOB_URL}${AZURE_BLOB_SAS_TOKEN}`
  );

  // get Container - full public read access

  const containerClient = blobService.getContainerClient("content");

  // upload file
  await createBlobInContainer(containerClient, file);

  return `${AZURE_STORAGE_BLOB_URL}content/html/${file.name}`;
};

export const validateUrl = (value) => {
  return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
    value
  );
};

export const getFileType = (url) => {
  try {
    const filetype = url?.split?.(".")?.pop?.();
    return filetype;
  } catch (error) {
    return "";
  }
};

export const GenerateUserToken = (req) => {
  return new Promise((resolve, reject) => {
    // axios.get(, {
    //   version: 'v1',
    //   header: { 'Ocp-Apim-Subscription-Key': ACTIVE_SUBSCRIPTION_KEY }
    // }).then((response) => resolve(response)).catch((error) => reject(error))
    //config.type = "text";
    axios
      .get(`${DOMAIN}${generateToken}${req}`, {
        headers: {
          version: "v1",
          "Ocp-Apim-Subscription-Key": ACTIVE_SUBSCRIPTION_KEY,
        },
      })
      .then((response) => {
        if (response.status === 401) {
          return;
        }
        resolve(response.data);
        //successHandler(response.data);
      })
      .catch((error) => {
        reject(error);
        // if (errorHandler) {
        //   errorHandler(error);
        //}
      });
  });
};

const getTimeDelta = (time, format) => {
  switch (format) {
    case "H":
      return Math.floor(time / (1000 * 60 * 60));
    case "D":
      return Math.floor(time / (1000 * 60 * 60 * 24));
    case "M":
      return Math.floor(time / (1000 * 60));
    default:
      return null;
  }
};

export const getToken = async () => {
  return new Promise(async (resolve, reject) => {
    let lastLogin = localStorage.getItem("LastLogin");
    let token = localStorage.getItem("token");
    let lastRefresh = localStorage.getItem("LastTokenRefresh");

    let timeDiffToken = moment().toDate().getTime() - parseInt(lastRefresh);
    let timeDiffLogin = moment().toDate().getTime() - parseInt(lastLogin);

    let currentDeltaToken = getTimeDelta(timeDiffToken, "M");
    let currentDeltaLogin = getTimeDelta(timeDiffLogin, "H");
    console.log("currentDeltaToken ", currentDeltaToken);
    if (currentDeltaToken <= 2) {
      console.log("token active");
      resolve(token);
    } else {
      console.log("currentDeltaLogin ", currentDeltaLogin);
      if (currentDeltaLogin <= UserExpiry) {
        console.log("token refreshed");
        let generatedToken = await GenerateUserToken("");
        localStorage.setItem("token", generatedToken.data);
        localStorage.setItem(
          "LastTokenRefresh",
          moment().toDate().getTime() + ""
        );
        resolve(generatedToken.data);
      }
      resolve(token);
    }
  });
};
